import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-[900px] flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-500">
          <span className="font-heading text-2xl font-bold leading-none">樱</span>
        </span>
        <p className="mt-6 font-heading text-5xl font-bold text-primary-500">404</p>
        <h1 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">这页好像被风吹走了</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的地址不存在，可能是链接写错了，或者内容已经调整。
        </p>
        <p className="mt-2 break-all rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
          {location.pathname}
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            回到首页
          </Link>
          <Link
            to="/category"
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            去动漫分类
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            搜索作品
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}